package features.videoDetails.data

import com.kinoshazam.data.GlobalStateRepository
import com.kinoshazam.data.Storage
import features.videoDetails.data.model.AddAllFavorites
import features.videoDetails.data.model.FavoriteData
import features.videoDetails.data.model.FavoriteEntity
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import models.FavoriteVideo
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

class FavoriteRepository(
    private val httpClient: HttpClient,
    private val storageUser: Storage,
    private val globalStateRepository: GlobalStateRepository,
) {

    val local: String get() = globalStateRepository.appLanguage.value.locale

    @OptIn(ExperimentalTime::class)
    suspend fun addFavorite(favoriteVideo: FavoriteVideo) {
        httpClient.post("favorite/add") {
            setBody(
                FavoriteData(
                    video = FavoriteData.Video(
                        videoId = favoriteVideo.videoId.toString(),
                        isTvShow = favoriteVideo.isTvShow,
                        changedAt = Clock.System.now().toString(),
                        title = favoriteVideo.title,
                        imageUrl = favoriteVideo.imageUrl,
                        isDeleted = false,
                    ),
                )
            )
        }
    }

    @OptIn(ExperimentalTime::class)
    suspend fun deleteFavorite(videoId: Int) {
        httpClient.post("favorite/delete") {
            setBody(
                FavoriteData(
                    video = FavoriteData.Video(
                        videoId = videoId.toString(),
                        isTvShow = false,
                        changedAt = Clock.System.now().toString(),
                        isDeleted = true,
                    ),
                )
            )
        }
    }

    suspend fun getFavoriteList(): List<FavoriteEntity> {
        return httpClient.get("favorite/getAll").body<List<FavoriteEntity>>()
    }

    suspend fun syncFavorites(videos: List<FavoriteEntity>): List<FavoriteEntity> {
        val result = httpClient.post("favorite/addAll") {
            setBody(AddAllFavorites(videos))
        }.body<List<FavoriteEntity>>()
        return result
    }
}
